export const NOTE_CONTENT_PREVIEW_MAX_LENGTH = 120
export const NOTE_DATE_FORMAT = 'MMM d, yyyy'

export const MENU_ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'right',
} as const

export const MENU_TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'right',
} as const

import { getCurrentSiteId } from '../../../../constants/site.constants'

export const getSiteId = getCurrentSiteId

export const GQTY_QUERY_OPTIONS = {
  suspense: false,
} as const

import { SLIDE_FROM } from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.constants'

export const getDialogAnimation = (isMobile: boolean) => ({
  animation: isMobile && SLIDE_FROM.BOTTOM,
})
